export const ML_PER_OZ = 29.5735;
export const G_PER_LB = 453.592;

export function mlToOz(ml: number): number {
  return Math.round((ml / ML_PER_OZ) * 10) / 10;
}

export function ozToMl(oz: number): number {
  return Math.round(oz * ML_PER_OZ);
}

export function gramsToLbs(g: number): number {
  return Math.round((g / G_PER_LB) * 100) / 100;
}

export function lbsToGrams(lbs: number): number {
  return Math.round(lbs * G_PER_LB);
}

export function formatVolume(ml: number, imperial: boolean): string {
  return imperial ? `${mlToOz(ml)}oz` : `${ml}mL`;
}

export function formatWeight(g: number, imperial: boolean): string {
  return imperial ? `${gramsToLbs(g)}lbs` : `${g}g`;
}
